import baseAPI from '@/api/base';
import { EditMilestone, GetMilestone, RegisterMilestone } from '@/dtos/milestone.dto';
import {
  DELETE_MILESTONE_URL,
  EDIT_MILESTONE_URL,
  GET_MILESTONE_URL,
  REGISTER_MILESTONE_URL,
  TOGGLE_MILESTONE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Milestone {
  static getMilestones = async (getMilestone: GetMilestone): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_MILESTONE_URL, {
      params: getMilestone,
    });
    console.log('response', response);
    return response;
  };

  static registerMilestone = async (
    registerMilestone: RegisterMilestone
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_MILESTONE_URL, {
      ...registerMilestone,
    });
    console.log('response', response);
    return response;
  };

  static editMilestone = async (editMilestone: EditMilestone): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_MILESTONE_URL, {
      ...editMilestone,
    });
    return response;
  };

  static toggleMilestoneIsActive = async (
    editMilestone: EditMilestone
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_MILESTONE_IS_ACTIVE_URL,
      {
        ...editMilestone,
      }
    );
    return response;
  };

  static deleteMilestone = async (milestoneId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_MILESTONE_URL}/${milestoneId}`
    );
    return response;
  };
}

export default Milestone;

